import dropdownVariables from './dropdownVariables';

export default dropdownVariables;
